import { pipe } from "fp";

import { type, creator, reducer } from "~/Action";
import * as ELD from "~/ELD";
import { useSelector } from "~/State";

import * as Type from "./Type";

export * as Type from "./Type";

export type Sort = {
  readonly type: Type.Type;
  readonly direction: Direction.Direction;
};

export const initial = (): Sort => ({
  type: Type.dateOfSubmission(),
  direction: Direction.descending(),
});

export const equals = (a: Sort) => (b: Sort): boolean =>
  a.type === b.type && a.direction === b.direction;

export const useActive = (): Sort =>
  useSelector({ equals, select: ({ elds: { sort } }) => sort.active });

export namespace Direction {
  export type Direction = ReturnType<typeof ascending | typeof descending>;
  export const ascending = () => "ASCENDING" as const;
  export const descending = () => "DESCENDING" as const;
}

export namespace State {
  export type State = { readonly active: Sort };
  export const initial = (): State => ({
    active: {
      type: Type.dateOfSubmission(),
      direction: Direction.ascending(),
    },
  });
}

export namespace Action {
  export namespace Updated {
    export const { TYPE, create, reduce } = pipe(
      type("ELDs updated sort" as const),
      creator((sort: Pick<ELD.Sort.Sort, "type">) => ({
        sort,
      })),
      reducer(
        ({ state, action: { sort } }) =>
          (state.elds.sort.active = updateSort(state.elds.sort.active, sort))
      )
    );
  }

  const updateSort = (previous: Sort, sort: Pick<Sort, "type">): Sort =>
    previous.direction === Direction.ascending()
      ? initial()
      : {
          ...sort,
          direction:
            previous.type === sort.type &&
            previous.direction === ELD.Sort.Direction.descending()
              ? ELD.Sort.Direction.ascending()
              : ELD.Sort.Direction.descending(),
        };
}
